export const GoogleMapApiConfig = 'AIzaSyC4ZNOrMAvIGmV87g8qDSO9kDefxJC6O24';